import { Tag } from "antd";

interface Props {
    data: any
}
const Capabilities = (props: Props) => {
    const { data } = props;


    return (
        <div className="flex flex-col gap-y-[16px]">
            {data?.channel_coverage && data?.channel_coverage?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Key Channel Coverage</p>
                    {data?.channel_coverage?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}

                </div>
            ) : (
                <></>
            )}
            {data?.service_capabilities && data?.service_capabilities?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Key Capabilities</p>
                    {data?.service_capabilities?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}
                </div>
            ) : (
                <></>
            )}
            {data?.warehousing && data?.warehousing?.length > 0 ? (
                <div className="">
                    <p className="mb-[6px] text-[12px] font-[500]">Warehousing</p>
                    {data?.warehousing?.map((item: any, index: number) => (
                        <Tag bordered={false} key={index}>{item}</Tag>
                    ))}
                </div>
            ) : (
                <></>
            )}

        </div>
    )
}

export default Capabilities